import axios from 'axios';

const client = axios.create({
    baseURL: import.meta.env.VITE_APP_BELOZ_V2_ENDPOINT,
});

export const checkUserService = async (phone) => {
    try {
        const { data } = await client.post(`/authentication/user/check`, {
            phone: {
                countryCode: '52',
                number: phone.replaceAll(' ', ''),
            },
        });
        if (!data.success) return { success: false };
        console.log('checkUserService', data);
        return {
            success: data.success,
            data: {
                hasAccount: data.data.hasAccount,
                hasAuthData: data.data.accountData.hasAuthData,
                userId: data.data.accountData.userId,
            },
        };
    } catch (error) {
        console.log('checkUserService', error);
        return { success: false };
    }
};

export const createUserService = async (phone) => {
    try {
        const { data } = await client.post(`/authentication/user`, {
            phone: {
                countryCode: '52',
                number: phone.replaceAll(' ', ''),
            },
        });
        return data;
    } catch (error) {
        console.log('createUserService', error);
        return { success: false };
    }
};